<template>
    <div
        id="sidebar-panel"
        class="relative flex"
    >
        <transition name="slide">
            <!-- Desktop Sidebar -->
            <aside
                v-show="isOpen"
                class="sticky hidden md:flex flex-col fixed top-0 left-0 h-full bg-green-900 text-white z-30 h-screen overflow-auto transition-all duration-300 md:block scrollbar-hide"
                :class="[collapsed ? 'w-16' : 'w-64']"
            >
                <div
                    class="sticky top-0 z-10 flex justify-center items-center h-16 py-3 bg-green-900 border-b border-green-800"
                >
                    <AppLogo :logoOnly="collapsed ?? true" />
                </div>
                <!-- Menu -->
                <div class="flex-1 overflow-y-auto scrollbar-hide">
                    <SidebarGroup
                        v-for="group in menuGroups"
                        :key="group.title"
                        :title="group.title"
                        :items="group.items"
                        :collapsed="collapsed"
                    />
                </div>

                <!-- Logout -->
                <div class="sticky bottom-0 z-10 p-4 bg-gray-900 border-t border-gray-700">
                    <button
                        @click="handleLogout"
                        class="flex items-center space-x-2 text-sm text-red-100 hover:text-red-300"
                    >
                        <LogoutIcon
                            class="w-5 h-5"
                            fill="#FFFFFF"
                        />
                        <span v-if="!collapsed">Logout</span>
                    </button>
                </div>
            </aside>
        </transition>

        <!-- Mobile Sidebar -->
        <transition name="fade">
            <MobileSidebar
                v-if="mobileOpen"
                :menu-groups="menuGroups"
                @close="mobileOpen = false"
                @logout="handleLogout"
            />
        </transition>
    </div>
</template>

<script>
    import AppLogo from '../Components/AppLogo.vue';
    import SidebarGroup from './SidebarGroup.vue';
    import MobileSidebar from './MobileSidebar.vue';
    import LogoutIcon from '../Components/Icons/LogoutIcon.vue';

    export default {
        name: 'Sidebar',

        components: {
            AppLogo,
            SidebarGroup,
            MobileSidebar,
            LogoutIcon,
        },

        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
            // loading: {
            //     type: Boolean,
            //     default: false,
            // },
            collapsed: Boolean,
            menuGroups: Array,
        },

        data() {
            return {
                mobileOpen: false,
                show: false,
            };
        },

        methods: {
            toggleMobile() {
                this.mobileOpen = !this.mobileOpen;
            },

            handleLogout() {
                this.$dialog
                    .confirm({
                        title: 'Confirm',
                        text: 'Are you sure you want to Logout?',
                    })
                    .then((result) => {
                        if (result.isOk) {
                            this.logout();
                        }
                    });
            },
        },
    };
</script>

<style scoped>
    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.3s ease;
    }
    .slide-enter,
    .slide-leave-to {
        transform: translateX(-100%);
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
